<template>
    <div>
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>

        <div class="m-6 bg-white shadow-sm rounded-xl border border-gray-100 overflow-hidden">
            <div class="px-4 py-4 sm:px-6 sm:py-5 border-b border-gray-100 flex items-center justify-between gap-4">
                <div class="flex items-center gap-2">
                    <div class="flex items-center justify-between">
                        <div>
                            <h1 class="text-2xl font-semibold text-gray-800">
                                {{ $t('gm.fatturato_per_agente') }}
                            </h1>
                            
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    class="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-200 transition"
                    @click="resetFilters"
                >
                    <span>{{ $t('gm.reset_filters') }}</span>
                </button>
            </div>
            

            <div class="grid grid-cols-1 md:grid-cols-6 gap-4 items-end p-6">
                <!-- DAL -->
                <div>
                    <label class="block text-xs font-medium text-black-600 mb-1">
                        {{ $t('gm.fatturato_filter_period_1') }}
                    </label>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.from') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_from"
                        @change="onDateChange('p1', 'from')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <!-- AL -->
                <div class="mr-2">
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.to') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_to"
                        @change="onDateChange('p1', 'to')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                
                
                <div class="ml-2">
                    <label class="block text-xs font-medium text-black-600 mb-1">
                        {{ $t('gm.fatturato_filter_period_2') }}
                    </label>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.from') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_uno_from"
                        @change="onDateChange('p2', 'from')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <!-- AL -->
                <div class="mr-2">
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.to') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_uno_to"
                        @change="onDateChange('p2', 'to')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <div class="ml-2">
                    <label class="block text-xs font-medium text-black-600 mb-1">
                        {{ $t('gm.fatturato_filter_period_3') }}
                    </label>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.from') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_due_from"
                        @change="onDateChange('p3', 'from')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <!-- AL -->
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.to') }}
                    </label>
                    <input
                        type="date"
                        v-model="d_due_to"
                        @change="onDateChange('p3', 'to')"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                
                

                
            </div>

            <!-- CHIP AGENTI SELEZIONATI: SOTTO la riga dei filtri -->
            

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end px-6 pb-6">
                            
                <div class="mr-2" v-if="$page.props.isAdminOrSuperAdmin">
                    <label class="block text-xs font-medium text-gray-600 mb-1">
                        {{ $t('gm.agents_filter') }}
                    </label>
                    <select
                        v-model="agentToAdd"
                        @change="onAgentSelected"
                        class="block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">{{ $t('gm.all_agents') }}</option>
                        <option
                            v-for="agent in allAgents"
                            :key="agent.code"
                            :value="agent.code"
                        >
                            {{ agent.label }}
                        </option>
                    </select>
                </div>
                
            </div>
            <div
                v-if="selectedAgents.length"
                class=" flex flex-wrap gap-1 pl-6"
            >
                <span
                    v-for="code in selectedAgents"
                    :key="code"
                    class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs text-blue-700"
                >
                    <span>
                        {{ (allAgents.find(a => a.code === code)?.label) || code }}
                    </span>
                    <button
                        v-if="$page.props.isAdminOrSuperAdmin"
                        type="button"
                        class="text-blue-500 hover:text-blue-700"
                        @click="removeSelectedAgent(code)"
                        @change="reloadData"
                    >
                        ×
                    </button>
                </span>
            </div>


            <div class="p-0">
                <PageServerTable
                :headers="headers"
                :items="items"
                :items-length="total"
                :loading="loading"
                :reload-fn="reloadData"

                :items-per-page.sync="ipp"
                :items-per-page-options="[10, 25, 50, 100]"

                :sort-by="sortby"

                :page="page"
                show-current-page
                >
                    <template #item.fatt="{ item }">
                        <div class="tabular-nums" :class="getColorClass(item.fatt, item)">
                        {{ formatCurrency(item.fatt) }}
                        <div :class="percentColor(item.fatt, item.fatt_1prec)" class="text-xs">
                            {{ percentDiff(item.fatt, item.fatt_1prec) }}
                        </div>
                        </div>
                    </template>

                    <template #item.fatt_1prec="{ item }">
                        <div class="tabular-nums" :class="getColorClass(item.fatt_1prec, item)">
                        {{ formatCurrency(item.fatt_1prec) }}
                        </div>
                    </template>

                    <template #item.fatt_2prec="{ item }">
                        <div class="tabular-nums" :class="getColorClass(item.fatt_2prec, item)">
                        {{ formatCurrency(item.fatt_2prec) }}
                        </div>
                    </template>

                    <template #body.append>
                        <tr class="font-bold bg-gray-50">
                            <td colspan="5" class="text-right py-3 px-4 uppercase text-xs text-gray-500 italic">{{ $t('gm.totals') }}:</td>
                            <td class="py-3 px-4">
                                <div class="tabular-nums">
                                    {{ formatCurrency(totalFatt) }}
                                    <div :class="percentColor(totalFatt, totalFatt1)" class="text-xs">
                                        {{ percentDiff(totalFatt, totalFatt1) }}
                                    </div>
                                </div>
                            </td>
                            <td class="py-3 px-4 tabular-nums">
                                {{ formatCurrency(totalFatt1) }}
                            </td>
                            <td class="py-3 px-4 tabular-nums">
                                {{ formatCurrency(totalFatt2) }}
                            </td>
                        </tr>
                    </template>
                </PageServerTable>

            </div>
            
        </div>
        
        


    </div>
</template>

<script>

    import BreadCrumbs from '@/Components/BreadCrumbs.vue';
    import PageServerTable from '@/Components/PageServerTable.vue';

    export default {

        components: {
            BreadCrumbs, 
            PageServerTable
    
        },

        props: {
            loggedAgentCode: {
                type: [String, Number],
                default: null
            }
        },
        data() {
            return {
                navigation: [
                    { name: this.$t('ui.dashboard'), href: route('dashboard') },
                    { name: this.$t('modules.visite-commerciali'), href: route('modules.home', 'visite-commerciali') },
                    { name: this.$t('gm.fatturato_per_agente'), href: route('modules.visite-commerciali.fatturato-agente') }
                ], 
                periods: {
                    p1: { from: 'd_from',      to: 'd_to' },
                    p2: { from: 'd_uno_from',  to: 'd_uno_to' },
                    p3: { from: 'd_due_from',  to: 'd_due_to' },
                    },
                d_from : new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10),
                d_to : new Date().toISOString().slice(0, 10),
                d_uno_from: new Date(new Date().getFullYear() -1, 0, 2).toISOString().slice(0,10),
                d_uno_to: new Date(new Date().getFullYear() -1, 11, 32).toISOString().slice(0,10),
                d_due_from: '',
                d_due_to: '',
                lastValidDates: {},
                dateTimer: null,
                allAgents: [],        
                selectedAgents: [],  
                agentToAdd: '', 
                originalItems: [],
                items: [],
                sortby: [], 
                total: 0, 
                ipp: 10,
                page : 1,
                loading : false,
                headers : [
                    //per visualizzare le info basta decommentare
                    //{ title: 'Cod. Agente', key: 'agente', value: 'agente' },
                    { title: this.$t('gm.agent_name'), key: 'nome_agente', value: 'nome_agente', filterable: true, filtervalue: '' },
                    //{ title: 'Cliente', key: 'cliente', value: 'cliente'},
                    { title: this.$t('gm.company_name'), key:'rag_soc', value: 'rag_soc', filterable : true , filtervalue : '' },
                    { title: this.$t('gm.city'), key:'citta', value: 'citta'}, 
                    { title: this.$t('gm.address'), key: 'indirizzo', value: 'indirizzo'},
                    { title: this.$t('gm.phone'), key: 'telefono', value: 'telefono'},
                    { title: this.$t('gm.fatturato_period_1'), key: 'fatt', value: 'fatt' },
                    { title: this.$t('gm.fatturato_period_2'), key: 'fatt_1prec', value: 'fatt_1prec' },
                    { title: this.$t('gm.fatturato_period_3'), key: 'fatt_2prec', value: 'fatt_2prec' },
                ],
            }
        },
        computed: {
            filteredItems() {
                let data = Array.isArray(this.originalItems) ? this.originalItems : [];
        
                // Applica i filtri locali per ogni header filterable che abbiamo escluso dal server
                const localFilters = this.headers.filter(h => h.filterable && h.filtervalue && (h.key === 'rag_soc' || h.key === 'nome_agente'));

                localFilters.forEach(f => {
                    const q = f.filtervalue.toString().toLowerCase().trim();
                    data = data.filter(row =>
                        (row[f.key] || '').toString().toLowerCase().includes(q)
                    );
                });

                return data;
            },
            totalFatt() {
                return this.filteredItems.reduce((acc, item) => acc + (parseFloat(item.fatt) || 0), 0);
            },
            totalFatt1() {
                return this.filteredItems.reduce((acc, item) => acc + (parseFloat(item.fatt_1prec) || 0), 0);
            },
            totalFatt2() {
                return this.filteredItems.reduce((acc, item) => acc + (parseFloat(item.fatt_2prec) || 0), 0);
            }
        },
        methods : {
            reloadData(sortby = undefined, itemsPerPage = undefined, page = undefined) {
                this.loading = true;

                // allinea i parametri se arrivano dal PageServerTable
                if (sortby) this.sortby = sortby;
                if (itemsPerPage) this.ipp = itemsPerPage;
                
                if (page) {
                    this.page = page;
                } else {
                    this.page = 1;
                }

                const filters = {};
                this.headers.forEach(h => {
                if (h.filterable && h.filtervalue && h.key !== 'rag_soc' && h.key !== 'nome_agente') {
                    filters[h.key] = h.filtervalue;  
                }
                });
                console.log(new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10)); 
                console.log(this.d_from); 
                axios.get(route('modules.visite-commerciali.fatturato-agenti'), { 
                params: {
                    page: this.page,
                    itemsperpage: this.ipp,
                    d_from : this.d_from,
                    d_to : this.d_to,
                    d_uno_from: this.d_uno_from,
                    d_uno_to: this.d_uno_to,
                    d_due_from: this.d_due_from,
                    d_due_to: this.d_due_to,
                    agents: this.selectedAgents,
                    sortby: this.sortby,
                    ...filters
                }
                })
                .then(res => {
                
                    let allItems = [];
                    if (res.data && Array.isArray(res.data.items)) {
                        allItems = res.data.items;
                    } else if (Array.isArray(res.data)) {
                        allItems = res.data;
                    } else {
                        console.error("Formato dati non valido ricevuto dal server", res.data);
                        allItems = [];
                    }

                    
                    const totalItems = res.data.total ?? allItems.length;
                    this.total = Number.isFinite(Number(totalItems)) ? Number(totalItems) : 0;
                    
                    
                    this.originalItems = allItems;
                    
                    this.applyLocalFiltersAndPagination();
                })
                .finally(() => this.loading = false);
            },

            onAgentSelected() {
                
                if (!this.agentToAdd) {
                    this.selectedAgents = [];
                    return;
                }

                
                if (!this.selectedAgents.includes(this.agentToAdd)) {
                    this.selectedAgents.push(this.agentToAdd);
                }

                
                this.agentToAdd = '';
                this.reloadData(); 
            },

            removeSelectedAgent(code) {
                this.selectedAgents = this.selectedAgents.filter(c => c !== code);
                this.reloadData(); 
            },

            resetFilters() {
                if (this.dateTimer) clearTimeout(this.dateTimer);
                this.headers.forEach(h => {
                    if (h.filterable) h.filtervalue = '';
                }); 
                
                if (this.loggedAgentCode) {
                    
                    this.selectedAgents = [this.loggedAgentCode];
                } else {
                    this.selectedAgents = [];
                }
                
                
                this.agentToAdd = '';
                this.d_from = new Date(new Date().getFullYear(), 0, 2).toISOString().slice(0, 10); 
                this.d_to = new Date().toISOString().slice(0, 10); 
                this.d_uno_from = new Date(new Date().getFullYear() -1, 0, 2).toISOString().slice(0,10);
                this.d_uno_to = new Date(new Date().getFullYear() -1, 11, 32).toISOString().slice(0,10); 
                this.d_due_from = ''; 
                this.d_due_to = ''; 
                this.reloadData(); 
                this.saveLastValidDates();
                
            },

            loadAgents() {
                axios.get(route('modules.visite-commerciali.agenti-list'))
                    .then(res => {
                        this.allAgents = res.data;
                    });
            },

            getColorClass(value, item) {
                const n1 = parseFloat(item.fatt)       || 0;
                const n2 = parseFloat(item.fatt_1prec) || 0;
                const n3 = parseFloat(item.fatt_2prec) || 0;

                const current = parseFloat(value) || 0;

                const max = Math.max(n1, n2, n3);

                return current === max
                    ? 'text-green-600 font-semibold'
                    : 'text-red-600';
            },

            percentDiff(current, previous) {
                const c = parseFloat(current) || 0;
                const p = parseFloat(previous) || 0;

                if (p === 0) {
                    // Se il precedente è zero:
                    if (c === 0) return '0%';
                    return '+∞%'; // oppure puoi scegliere '+100%' o altro
                }

                const diff = ((c - p) / p) * 100;
                return (diff > 0 ? '+' : '') + diff.toFixed(1) + '%';
            },

            percentColor(current, previous) {
                const c = parseFloat(current) || 0;
                const p = parseFloat(previous) || 0;

                if (p === 0) return 'text-green-600 font-semibold';

                const diff = ((c - p) / p) * 100;

                return diff >= 0
                    ? 'text-green-600 font-semibold'
                    : 'text-red-600 font-semibold';
            },

            //filtro su valori locali
            applyLocalFiltersAndPagination() {
                const data = this.filteredItems;

                this.total = data.length;

                // paginazione locale
                const start = (this.page - 1) * this.ipp;
                const end   = start + this.ipp;
                this.items  = data.slice(start, end);
            },

            // recupera { from, to } per un periodo (p1/p2/p3)
            getRange(id) {
                const def = this.periods[id];
                return {
                from: this[def.from],
                to:   this[def.to],
                };
            },

            // true se il periodo ha entrambe le date valorizzate
            hasBothDates(id) {
                const r = this.getRange(id);
                return !!(r.from && r.to);
            },

            // true se il periodo ha entrambe le date valorizzate e complete (anno a 4 cifre)
            isDateComplete(dateStr) {
                if (!dateStr) return false;
                const parts = dateStr.split('-');
                if (parts.length !== 3) return false;
                const year = parts[0];
                return year && year.length === 4 && parseInt(year) > 1000;
            },

            // true se from <= to per quel periodo
            isValidRange(id) {
                const r = this.getRange(id);
                if (!this.isDateComplete(r.from) || !this.isDateComplete(r.to)) return false;

                const from = new Date(r.from);
                const to   = new Date(r.to);

                return from <= to;
            },

            // verifica sovrapposizione tra due range {from, to}
            rangesOverlap(a, b) {
                if (!this.isDateComplete(a.from) || !this.isDateComplete(a.to) || !this.isDateComplete(b.from) || !this.isDateComplete(b.to)) return false;

                const A1 = new Date(a.from);
                const A2 = new Date(a.to);
                const B1 = new Date(b.from);
                const B2 = new Date(b.to);

                // A1 <= B2 && B1 <= A2 → sovrapposti
                return A1 <= B2 && B1 <= A2;
            },

            // controlla tutte le coppie di periodi completi
            hasOverlaps() {
                const ids = Object.keys(this.periods);

                // costruiamo array con solo i periodi completi
                const ranges = ids
                .map(id => ({ id, ...this.getRange(id) }))
                .filter(r => this.isDateComplete(r.from) && this.isDateComplete(r.to));

                for (let i = 0; i < ranges.length; i++) {
                for (let j = i + 1; j < ranges.length; j++) {
                    if (this.rangesOverlap(ranges[i], ranges[j])) {
                    return true;
                    }
                }
                }
                return false;
            },

            // chiamata quando cambia una data (Da/A) di un periodo
            onDateChange(id, fieldType) {
                if (this.dateTimer) clearTimeout(this.dateTimer);
                
                this.dateTimer = setTimeout(() => {
                    const def = this.periods[id];
                    
                    // Se manca una delle due date o non sono complete, non facciamo nulla
                    if (!this.isDateComplete(this[def.from]) || !this.isDateComplete(this[def.to])) {
                        return;
                    }

                    // 1) Controllo bloccante: Da <= A
                    if (!this.isValidRange(id)) {
                        alert(this.$t('gm.date_range_error'));
                        this.restorePeriodDates(id);
                        return;
                    }

                    // 2) Controllo non bloccante: Sovrapposizioni (solo alert)
                    if (this.hasOverlaps()) {
                        alert(this.$t('gm.overlap_error'));
                    }

                    // 3) Salviamo lo stato, reset pagina e ricarichiamo
                    this.saveLastValidDates();
                    this.page = 1;
                    this.reloadData();
                }, 1000);
            },

            saveLastValidDates() {
                const backup = {};
                Object.values(this.periods).forEach(p => {
                backup[p.from] = this[p.from];
                backup[p.to]   = this[p.to];
                });
                this.lastValidDates = backup;
            },

            restorePeriodDates(id) {
                const def = this.periods[id];
                if (!this.lastValidDates || !Object.keys(this.lastValidDates).length) {
                // niente backup? non faccio nulla
                return;
                }

                this[def.from] = this.lastValidDates[def.from] ?? '';
                this[def.to]   = this.lastValidDates[def.to]   ?? '';
            },

        },

        mounted () 
        {
            if (this.loggedAgentCode) {
                this.selectedAgents = [this.loggedAgentCode];
            }
            
            this.reloadData(); 
            this.loadAgents(); 
            this.saveLastValidDates();
        },

    } 

</script>